import __vite_glob_0_0 from "./extensions/alternate.css.js";
import __vite_glob_0_1 from "./extensions/bluePlanet.css.js";
import __vite_glob_0_2 from "./extensions/deepSpace.css.js";
import __vite_glob_0_3 from "./extensions/default.css.js";
import __vite_glob_0_4 from "./extensions/kepler.css.js";
import __vite_glob_0_5 from "./extensions/mars.css.js";
import __vite_glob_0_6 from "./extensions/moon.css.js";
import __vite_glob_0_7 from "./extensions/purple.css.js";
import __vite_glob_0_8 from "./extensions/saturn.css.js";
import __vite_glob_0_9 from "./extensions/solarized.css.js";
import { themeLabels, presets } from "@scalar/themes";
import { nanoid } from "nanoid";
import { readonly } from "vue";
import customStyles from "./custom.css.js";
import { DocumentClasses } from "./document-classes.js";
import { slugify } from "@scalar-org/helpers/url";
const extensionStyles = /* @__PURE__ */ Object.assign({
  "./extensions/alternate.css": __vite_glob_0_0,
  "./extensions/bluePlanet.css": __vite_glob_0_1,
  "./extensions/deepSpace.css": __vite_glob_0_2,
  "./extensions/default.css": __vite_glob_0_3,
  "./extensions/kepler.css": __vite_glob_0_4,
  "./extensions/mars.css": __vite_glob_0_5,
  "./extensions/moon.css": __vite_glob_0_6,
  "./extensions/purple.css": __vite_glob_0_7,
  "./extensions/saturn.css": __vite_glob_0_8,
  "./extensions/solarized.css": __vite_glob_0_9
});
const PresetUids = {
  alternate: "2skUDSH4S8HYFF9yXysr-",
  default: "qTQR9jSM8E-LihpyZzPOi",
  moon: "DG9ZUNp5lJhDeX_kPX4Bl",
  purple: "pE_1ysxcZ-y2LM1GGNBUv",
  solarized: "BdGVG1vf-4nYl3wJKyj8l",
  bluePlanet: "X12IfAvl7ue-42V2lW40S",
  deepSpace: "K8b38NWQiicq4-zXGXKdI",
  saturn: "1jyAjmbIZQG-RUU4Ugk9o",
  kepler: "jZ6dnWbtqQ0Hz3s9jLPH0",
  mars: "YY4LQgwiXix55-TmMz9qd"
};
const getStyles = (id) => {
  const styles = [presets[id]];
  const extensionFile = `./extensions/${id}.css`;
  if (extensionStyles[extensionFile])
    styles.push(extensionStyles[extensionFile]);
  return styles.join("\n");
};
const getTheme = (id) => ({
  name: themeLabels[id],
  identifier: id,
  description: "",
  uid: PresetUids[id],
  theme: getStyles(id)
});
const fallbackTheme = getTheme("default");
const getStarterTheme = (name) => ({
  name,
  identifier: slugify(name),
  description: "",
  uid: nanoid(),
  theme: customStyles
});
const themePresets = readonly([
  getTheme("default"),
  getTheme("alternate"),
  getTheme("purple"),
  getTheme("solarized"),
  getTheme("moon"),
  getTheme("bluePlanet"),
  getTheme("deepSpace"),
  getTheme("saturn"),
  getTheme("kepler"),
  getTheme("mars")
]);
export {
  DocumentClasses,
  fallbackTheme,
  getStarterTheme,
  themePresets
};
//# sourceMappingURL=index.js.map
